import { useEffect } from 'react'
import { Backdrop, Grid, IconButton } from '@mui/material'

import { runClientEff } from '@ecm/effect'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Player from '@ecm/ui/element/Player'

import closeIcon from '/public/images/icon/close-white.svg'

type VideoProps = {
  isOpen: boolean
  onClose: () => void
}

const Video = ({ isOpen, onClose }: VideoProps) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto'
  }, [isOpen])

  return (
    <Backdrop
      open={isOpen}
      sx={{
        alignItems: 'start',
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        overflowY: 'auto',
        pb: '1em',
        pt: { md: '7em', xs: '6em' },
        px: '1em',
        zIndex: 10000,
      }}
    >
      <Grid
        container
        direction={{ sm: 'row', xs: 'column' }}
        alignItems={{ sm: 'start', xs: 'end' }}
        wrap="nowrap"
        maxWidth="1500px"
      >
        {isOpen && (
          <Player
            url={runClientEff(eff => eff.ask().mobileAppsVideoUrl)}
            config={{ vimeo: { playerOptions: { autoplay: true } } }}
          />
        )}
        <IconButton
          onClick={onClose}
          sx={{
            order: { sm: 'unset', xs: -1 },
            pb: '0.5em',
          }}
        >
          <CloudflareImage src={closeIcon} />
        </IconButton>
      </Grid>
    </Backdrop>
  )
}

export default Video
